import React from "react";
import { connect } from "react-redux";
import "rc-slider/assets/index.css";
import { Input, Row, Col, Label } from "reactstrap";
import Slider, { createSliderWithTooltip } from "rc-slider";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import CondtionTypeList from "../../../../areas/form/conditions/components/CondtionTypeList";
import DividerSettings from "./DividerSettings";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { deepClone } from "../../../../../helpers/objectHelper";
import { pageActions } from "../../../../../store/actions/cms/page/page.action";
import ColorPickerFacade from "../../../../../components/UI/Buttons/ColorPickerFacade";
import ImageSettings from "./ImageSettings";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { templateHelper } from "../../../../areas/template/helpers/templateHelper";
import MapSettings from "./MapSettings";
import ButtonSettings from "./ButtonSettings";
import TemplateButtonSettings from "../../../../areas/template/components/ButtonSettings/ButtonSettings";
import VideoSettings from "./VideoSettings";
import ContainerSettings from "../../Container/Settings/ContainerSettings";
import CalendarInvitationSettings from "./CalendarInvitationSettings";

const SliderWithTooltip = createSliderWithTooltip(Slider);

function percentFormatter(v) {
  return `${v} %`;
}

class ContentSettings extends React.Component {
  state = { activeTab: new Array(2).fill("1"), isChange: false };
  componentDidMount() {
    this.setState({
      activeTab: new Array(2).fill("1"),
    });
  }

  handleSoftUpdate = (element) => {
    const { dispatch, cms, page } = this.props;
    const { enviroment } = cms;
    if (enviroment === sourceTypes.FORM) dispatch(formActions.updateFormElement(element));
    if (enviroment === sourceTypes.PAGE) dispatch(pageActions.updatePageElement(element, null, page));
    if (enviroment === sourceTypes.TEMPLATE) {
      const template = deepClone(this.props.template);
      const newTemplate = templateHelper.handleElementUpdates(element, template);
      dispatch(templateActions.softUpdate(newTemplate));
    }
  };
  handleSlider(e, path) {
    const names = path.split(".");
    const selectedElement = deepClone(this.props.selectedElement);

    if (path === "data.style.width") {
      selectedElement[names[0]][names[1]][names[2]] = e + "%";
    } else if (path === "data.titleWidth") {
      selectedElement.data.inputWidth = 100 - e;
      selectedElement[names[0]][names[1]] = e /* + '%' */;
    } else if (path === "data.inputWidth") {
      selectedElement.data.titleWidth = 100 - e;
      selectedElement[names[0]][names[1]] = e /* + '%' */;
    }
    this.handleSoftUpdate(selectedElement);
  }
  toggle = (tabPane, tab) => {
    const newArray = this.state.activeTab.slice();
    newArray[tabPane] = tab;
    this.setState({
      activeTab: newArray,
    });
  };
  handleChange = (e, path, val) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedElement);
    let value = null;
    if (val && val.hex !== undefined) {
      const { r, g, b, a } = val.rgb;
      value = `rgba(${r},${g},${b},${a})`;
    } else if (val) value = val;
    else value = e.target.value;

    if (names.length === 2) {
      element[names[0]][names[1]] = value;
    } else if (names.length === 3) {
      element[names[0]][names[1]][names[2]] = value;
    } else if (names.length === 4) {
      element[names[0]][names[1]][names[2]][names[3]] = value;
    }
    this.handleSoftUpdate(element);
  };
  handleSpaceOnChange = (e, path, dir) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedElement);
    const spaceValue = element[names[0]][names[1]];
    let value = e.target.value;
    let splitted = spaceValue.toString().split(" ");
    if (splitted.length > 1) {
      splitted[dir] = value + "px";
      splitted = splitted.join(" ");
      element[names[0]][names[1]] = splitted;
    } else {
      let newString = `${splitted[0]}px ${splitted[0]}px ${splitted[0]}px ${splitted[0]}px`;
      newString = newString.split(" ");
      newString[dir] = value + "px";

      element[names[0]][names[1]] = newString.join(" ");
    }
    this.handleSoftUpdate(element);
  };
  convertSpaceValue = (value, index) => {
    let splitted = value.toString().split(" ");
    if (splitted.length > 1) {
      return parseInt(splitted[index]);
    } else {
      return parseInt(splitted[0]);
    }
  };
  expandArea = (area) => {
    this.setState({ [area]: !this.state[area] });
  };
  render() {
    const { selectedElement, enviroment } = this.props;

    return (
      selectedElement && (
        <React.Fragment>
          <div>
            <ListExpansion footer={false} icon="fa fa-sticky-note" defaultExpanded={true} description="ContentSettings">
              {/*         <TextOverHeaderRow bg="#fff" label="ContentSettings" /> */}
              {selectedElement.data.padding !== undefined ? (
                <React.Fragment>
                  <Row>
                    <Col className="list-setting-item-title">
                      <Label>
                        <SystemLabel name="Padding" />
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="list-setting-item-title" style={{ display: "inline-flex" }}>
                      <div>
                        <Input
                          autoComplete="jirango-nofill"
                          type="number"
                          onChange={(e) => this.handleSpaceOnChange(e, `data.padding`, 0)}
                          value={this.convertSpaceValue(selectedElement.data.padding, 0)}
                        />
                        <em>
                          <p style={{ textAlign: "center" }} className="text-muted">
                            <SystemLabel name="Top" />
                          </p>
                        </em>
                      </div>
                      <div>
                        <Input
                          autoComplete="jirango-nofill"
                          type="number"
                          onChange={(e) => this.handleSpaceOnChange(e, `data.padding`, 1)}
                          value={this.convertSpaceValue(selectedElement.data.padding, 1)}
                        />
                        <em>
                          <p style={{ textAlign: "center" }} className="text-muted">
                            <SystemLabel name="Right" />
                          </p>
                        </em>
                      </div>
                      <div>
                        <Input
                          autoComplete="jirango-nofill"
                          type="number"
                          onChange={(e) => this.handleSpaceOnChange(e, `data.padding`, 2)}
                          value={this.convertSpaceValue(selectedElement.data.padding, 2)}
                        />
                        <em>
                          <p style={{ textAlign: "center" }} className="text-muted">
                            <SystemLabel name="Bottom" />
                          </p>
                        </em>
                      </div>
                      <div>
                        <Input
                          autoComplete="jirango-nofill"
                          type="number"
                          onChange={(e) => this.handleSpaceOnChange(e, `data.padding`, 3)}
                          value={this.convertSpaceValue(selectedElement.data.padding, 3)}
                        />
                        <em>
                          <p style={{ textAlign: "center" }} className="text-muted">
                            <SystemLabel name="Left" />
                          </p>
                        </em>
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>
              ) : null}
              {selectedElement.data.margin !== undefined ? (
                <React.Fragment>
                  <Row>
                    <Col className="list-setting-item-title">
                      <Label>
                        <SystemLabel name="Margin" />
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="list-setting-item-title" style={{ display: "inline-flex" }}>
                      <div>
                        <Input
                          autoComplete="jirango-nofill"
                          type="number"
                          onChange={(e) => this.handleSpaceOnChange(e, `data.margin`, 0)}
                          value={this.convertSpaceValue(selectedElement.data.margin, 0)}
                        />
                        <em>
                          <p style={{ textAlign: "center" }} className="text-muted">
                            <SystemLabel name="Top" />
                          </p>
                        </em>
                      </div>
                      <div>
                        <Input
                          autoComplete="jirango-nofill"
                          type="number"
                          onChange={(e) => this.handleSpaceOnChange(e, `data.margin`, 1)}
                          value={this.convertSpaceValue(selectedElement.data.margin, 1)}
                        />
                        <em>
                          <p style={{ textAlign: "center" }} className="text-muted">
                            <SystemLabel name="Right" />
                          </p>
                        </em>
                      </div>
                      <div>
                        <Input
                          autoComplete="jirango-nofill"
                          type="number"
                          onChange={(e) => this.handleSpaceOnChange(e, `data.margin`, 2)}
                          value={this.convertSpaceValue(selectedElement.data.margin, 2)}
                        />
                        <em>
                          <p style={{ textAlign: "center" }} className="text-muted">
                            <SystemLabel name="Bottom" />
                          </p>
                        </em>
                      </div>
                      <div>
                        <Input
                          autoComplete="jirango-nofill"
                          type="number"
                          onChange={(e) => this.handleSpaceOnChange(e, `data.margin`, 3)}
                          value={this.convertSpaceValue(selectedElement.data.margin, 3)}
                        />
                        <em>
                          <p style={{ textAlign: "center" }} className="text-muted">
                            <SystemLabel name="Left" />
                          </p>
                        </em>
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>
              ) : null}
              <hr />
              <Row>
                <Col className="list-setting-item-title">
                  <Label>
                    <SystemLabel name="BackgroundColor" />
                  </Label>
                </Col>
                <Col className="list-setting-item-input">
                  <ColorPickerFacade color={selectedElement.data.backgroundColor} onChange={(color, e) => this.handleChange(null, "data.backgroundColor", color)} path="data.backgroundColor" />
                </Col>
              </Row>
            </ListExpansion>
            <br />
            {selectedElement.props.type === "IMG" ? <ImageSettings /> : null}
            {selectedElement.props.type === "MAP" ? <MapSettings /> : null}
            {selectedElement.props.type === "BUTTON" ? (
              <React.Fragment>
                {" "}
                <ButtonSettings /> <br />{" "}
                <ListExpansion footer={false} icon="fa fa-image" description="TemplateButtonSettings" defaultExpanded={false}>
                  <TemplateButtonSettings />
                </ListExpansion>{" "}
              </React.Fragment>
            ) : null}
            {selectedElement.props.type === "DIVIDER" ? <DividerSettings /> : null}
            {selectedElement.props.type === "CALENDAR_INVITATION" ? <CalendarInvitationSettings /> : null}
            {selectedElement.props.type === "VIDEO" ? <VideoSettings /> : null}
            <CondtionTypeList element={selectedElement} toggleConditionModal={this.props.toggleConditionModal} />
            {this.props.form.selectedContainer ? <ContainerSettings /> : null}
          </div>
        </React.Fragment>
      )
    );
  }
}

function mapStateToProps(state) {
  const { enviroment } = state.cms;
  let selectedElement = null;
  if (enviroment === sourceTypes.FORM) selectedElement = state.form.selectedElement;
  if (enviroment === sourceTypes.PAGE) selectedElement = state.page.selectedElement;
  if (enviroment === sourceTypes.TEMPLATE) selectedElement = state.template.selectedElement;
  return {
    form: state.form,
    page: state.page,
    template: state.template.template,
    cms: state.cms,
    selectedElement,
  };
}

export default connect(mapStateToProps)(ContentSettings);
